import { jsx as _jsx } from "react/jsx-runtime";
const PlusCircleIcon = (props) => {
    return (_jsx("svg", Object.assign({ width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M7 0C3.136 0 0 3.136 0 7C0 10.864 3.136 14 7 14C10.864 14 14 10.864 14 7C14 3.136 10.864 0 7 0ZM10.5 7.7H7.7V10.5H6.3V7.7H3.5V6.3H6.3V3.5H7.7V6.3H10.5V7.7Z", fill: props.color }) })));
};
PlusCircleIcon.defaultProps = {
    color: 'white',
};
export default PlusCircleIcon;
